import { ReactNode } from "react";
import { ContainerContext } from "./container.context";
import Container, { container } from "src/shared/services/container/container.service";

interface ContainerServicesProviderProps {
    children: ReactNode;
    services?: Container;
}

function ContainerProvider(props: ContainerServicesProviderProps) {
    // * Props
    const { children, services = container } = props;

    // * Render
    return <ContainerContext value={services}>{children}</ContainerContext>;
}

export default ContainerProvider;
